import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { ConfigReducer } from './config';
import { AuthReducer } from './auth'
import {AnalyticsReducer} from './analytics'
import {ReportsReducer} from './reports'
import selectedLocations from './filterLocation/filterLocationReducers'
import { topItemReducer, lowItemReducer } from './salesLoader';
import { InventoryReducer } from './inventory';
import { ProductAnalyticsReducer } from './productAnalytics';
export default combineReducers({
    config: ConfigReducer.Reducer,
    routing: routerReducer,
    selectedLocations,
    auth:  AuthReducer.Reducer,
    analytics: AnalyticsReducer.Reducer,
    inventory: InventoryReducer.Reducer,
    topItemLoader: topItemReducer,
    lowItemLoader: lowItemReducer,
    reports: ReportsReducer.Reducer,
    product_analytics: ProductAnalyticsReducer.Reducer,

})



// WEBPACK FOOTER //
// ./src/modules/index.js